import {Tab, Tabs} from '@mui/material';
import type {FunctionComponent} from 'react';
import {styledMod} from '@/utils/styled-mod.tsx';
import styles from './styles.module.css';

type SwapWidgetNewTabsProps = {
  tabs: string[];
  activeTab?: number;
  onTabChange: (tabNumber: number) => void;
}

const SwapWidgetNewTabsContainer = styledMod('div', styles['swap-widget-new-tabs'])

export const SwapWidgetNewTabs: FunctionComponent<SwapWidgetNewTabsProps> = (props: SwapWidgetNewTabsProps) => {

  const onTabChange = (_: any, tabNumber: number) => {
    props.onTabChange(tabNumber);
  }

  return <SwapWidgetNewTabsContainer>
    <Tabs value={props.activeTab} onChange={onTabChange}>
      <Tab label={props.tabs[0]} value={0}/>
      <Tab label={props.tabs[1]} value={1}/>
    </Tabs>
  </SwapWidgetNewTabsContainer>
} 